import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";
import { Organiser } from "../../../models/organisers/organiser.model";

export const adminOrganiserAdapter: EntityAdapter<Organiser> = createEntityAdapter<Organiser>({ 
    selectId: (organiser) => organiser.organiserID,
    sortComparer: (a,b) => a.name.localeCompare(b.name) 
});